(function (angular) {
    'use strict';
 
    angular.module('GorillaBoy.FileBrowser')
    .directive('gbFileBrowserThumbnailView', ['$timeout', 'SourceConstant', 'ClientMetricsService', 'DraggableStyle', 'MetricEvents', 'AppConstants',
        function ($timeout, SourceConstant, ClientMetricsService, DraggableStyle, MetricEvents, AppConstants) {
        return {
            restrict: 'E',
            templateUrl: './file-browser/thumbnail_view_type.html',
            link: function (scope, iElement, iAttrs, controller) {
                ClientMetricsService.recordCounterEvent(MetricEvents.THUMBNAIL_VIEW, 1);
                var draggableOptions = {
                        containment: $("#gallery-view"), // Restrict dragging to the parent div.
                        revert: "invalid", // Snap to original position if dragging is canceled.
                        distance: 3, // 3 pixels the mouse must move before dragging should start
                        start: function (event, ui) {
                            $(this).css("z-index", "99");
                            $(this).css("background-color", DraggableStyle.DRAGGABLE_BACKGROUND_ACTIVE);
                            scope.dragging = true;
                        },
                        stop: function (event, ui) {
                            $(this).css("background-color", DraggableStyle.DRAGGABLE_BACKGROUND_INACTIVE);
                            scope.dragging = false;
                        }
                    },
                    droppableOptions = {
                        drop: function (event, ui) {
                            // Set dropping flat to prevent opening the resource
                            ClientMetricsService.recordCounterEvent(MetricEvents.THUMBNAIL_VIEW_DROPPED, 1);
                            scope.dropping = true;
                            // Prepare parames
                            var moveId,
                                moveLocation,
                                moveNewParentFolderId,
                                moveSharedModalName;

                            //TODO: Firefox returns wrong data-id, should find a better way to fix it.
                            var moveFileId = ui.draggable.data('id');
                            if (moveFileId === '{{folder.Id}}' || moveFileId === '{{document.Id}}') {
                                scope.moveId = ui.draggable.attr('id');
                            } else {
                                scope.moveId = ui.draggable.data('id');
                            }

                            if ($(ui.helper).hasClass('thumbnail-folder')) {
                                moveLocation = 'folders/';
                            } else if ($(ui.helper).hasClass('thumbnail-file')) {
                                moveLocation = 'documents/';
                            }
                            var newParentFolderId = $(this).data('id');
                            if (newParentFolderId === '{{folder.Id}}' || newParentFolderId === '{{document.Id}}') {
                                moveNewParentFolderId = $(this).attr('id');
                            } else {
                                moveNewParentFolderId = $(this).data('id');
                            }

                            // Move
                            var movePromise;
                            if (scope.inShared() || scope.folderState.deepInSharedFolder) {
                                moveSharedModalName = $(this).data('name');
                                movePromise = scope.showMoveIntoSharedFolderModal(scope.moveId, moveLocation, moveNewParentFolderId, moveSharedModalName);
                            } else {
                                movePromise = scope.moveIntoFolder(scope.moveId, moveLocation, moveNewParentFolderId);
                            }
                            movePromise.then(function() {
                                // Remove the dragged element.
                                $(ui.draggable).remove();
                            }, function() {
                                ui.draggable.animate(ui.draggable.data('ui-draggable').originalPosition,"slow");
                            }).finally(function() {
                                scope.dropping = false;
                            });
                            return false;
                        }
                    };
 
                var documentsWatchFnPromise, foldersWatchFnPromise;
                scope.$watchCollection('documents', function (documentsNew, documentsOld) {
                    if (!documentsNew || !documentsNew.length) {
                        return;
                    }
                    if (documentsWatchFnPromise) {
                        $timeout.cancel(documentsWatchFnPromise);
                        documentsWatchFnPromise = null;
                    }
                    // Documents changed
                    documentsWatchFnPromise = $timeout(function () {
                            $(".draggable").draggable(draggableOptions);
                        }, 250);
                });
 
                scope.$watchCollection('folders', function (foldersNew, foldersOld) {
                    if (!foldersNew || !foldersNew.length) {
                        return;
                    }
                    if (foldersWatchFnPromise) {
                        $timeout.cancel(foldersWatchFnPromise);
                        foldersWatchFnPromise = null;
                    }
                    foldersWatchFnPromise = $timeout(function () {
                        // See http://api.jqueryui.com/draggable/.
                        $(".draggable").draggable(draggableOptions);
 
                        // See http://api.jqueryui.com/droppable/.
                        // Setup the drop handler for folders.
                        $(".droppable").droppable(droppableOptions);
                    }, 250);
                });
 
                if (scope.folderState.view !== AppConstants.ViewTypes.SEARCH_TYPE) {
                    /* show upload progress bar after the page is rendered.
                     * why in timeout? ==> https://stackoverflow.com/questions/12240639/how-can-i-run-a-directive-after-the-dom-has-finished-rendering
                     */
                    $timeout(function () {
                        scope.showFolderUploadProgressBar();
                    });
                }
 
            },
            controller: ['$scope', '$rootScope', 'AppConstants', 'ContentTypeFormatter',
                function ($scope, $rootScope, AppConstants, ContentTypeFormatter) {
 
                    // AppConstant bindings
                    var documentStatus = AppConstants.DocumentStatus;
                    $scope.showSortDropdown = false;

                    $scope.documentToBeDeleted = null;
                    $scope.hasPreview = function(doc) {
                        if (angular.isDefined(doc.VersionMetadata)) {
                            if (!angular.isObject(doc.VersionMetadata.ThumbnailUrlMap) || !angular.isDefined(doc.VersionMetadata.ThumbnailUrlMap.SMALL)) {
                                if (doc.VersionMetadata.PdfPreviewStatus !== documentStatus.DOCUMENT_STATUS_PENDING && doc.VersionMetadata.PdfPreviewStatus !== documentStatus.DOCUMENT_STATUS_ACTIVE) {
                                    return false;
                                }
                            }
                        }
                        return true;
                    };
                    $scope.largeThumbnail = function (doc) {
                        var returnString = $scope.THUMBNAIL_VIEW_NO_PREVIEW;
 
                        if (angular.isDefined(doc.VersionMetadata)) {
                            if (angular.isObject(doc.VersionMetadata.ThumbnailUrlMap) && angular.isDefined(doc.VersionMetadata.ThumbnailUrlMap.SMALL)) {
                                returnString = doc.VersionMetadata.ThumbnailUrlMap.SMALL;
                            } else {
                                if (doc.VersionMetadata.PdfPreviewStatus === documentStatus.DOCUMENT_STATUS_PENDING) {
                                    returnString = $scope.THUMBNAIL_PREVIEW_IN_PROGRESS;
                                } else if (doc.VersionMetadata.PdfPreviewStatus === documentStatus.DOCUMENT_STATUS_ACTIVE) {
                                    returnString = determineThumbnailUrlFromContentType(doc.VersionMetadata.ContentType);
                                } else {
                                    returnString = $scope.THUMBNAIL_VIEW_NO_PREVIEW;
                                }
                            }
                        }
                        return returnString;
                    };
                    $scope.overlayText = function (doc) {
                        var overlayText = '';
                        if (angular.isDefined(doc.VersionMetadata)) {
                            if (!angular.isObject(doc.VersionMetadata.ThumbnailUrlMap) || !angular.isDefined(doc.VersionMetadata.ThumbnailUrlMap.SMALL)) {
                                if (doc.VersionMetadata.PdfPreviewStatus === documentStatus.DOCUMENT_STATUS_PENDING){
                                    overlayText = 'PREVIEW_IN_PROGRESS';
                                } else {
                                    overlayText = 'NO_PREVIEW';
                                }
                            }
                        }
                        return overlayText;
                    };

                    $scope.openResourceIfNoSpecialEvent = function(resource, resourceType) {
                        if (resource.insideInput) {
                            resource.insideInput = false;
                            return;
                        }
                        if ($scope.layout.view === AppConstants.ViewTypes.RECOVERY_TYPE) {
                            return;
                        }
                        if ($scope.dragging || $scope.dropping) {
                            return;
                        }
                        $rootScope.goto('/' + resourceType + '/' + resource.Id);
                        return;
                    };

                    $scope.toggleSortDropdownMenu = function() {
                        $scope.showSortDropdown = !$scope.showSortDropdown;
                    };
 
                    function determineThumbnailUrlFromContentType(type) {
                        var fileType = ContentTypeFormatter.getTypeCategory(type),
                            supportedFileFormats = AppConstants.SupportedFileFormatThumbnail;
                        if (supportedFileFormats.indexOf(fileType) === -1) {
                            fileType = 'Other';
                        }
                        return AppConstants.ThumbnailUrlMap[fileType];
                    }
                }
            ]
        };
    }])
    .directive('errorPreviewSrc', ['$log', function ($log) {
        // Used to bind a src to a default preview src in the case of error
        return {
            link: function(scope,element, attrs) {
                element.bind('error', function() {
                    element.addClass('large-no-preview');
                    element.attr('src', scope.DEFAULT_PREVIEW_ICON);
                    scope.document.overlayText = 'ERROR_LOADING_PREVIEW';
                    scope.$digest();
                });
            },
            controller: ['$scope', function ($scope) {
                // AppConstant bindings
                $scope.DEFAULT_PREVIEW_ICON = 'images/nopreview-large.png';
            }]
        };
    }]);
}(angular));